import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import Spinner from 'react-bootstrap/Spinner';
import { onError } from "../libs/errorLib";
import { API } from 'aws-amplify';
import Plot from 'react-plotly.js';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { startCase } from 'lodash';
import { myListTimeSeriess } from '../graphql/my.queries';


// custom data fetching/processing hook
// https://www.robinwieruch.de/react-hooks-fetch-data
const useRestApi = (Symbol, Frequency, CsvFile, RiskDriver, NextStepModel, EstimationApproach) => {
  const [symbol, setSymbol] = useState(Symbol);
  const [frequency, setFrequency] = useState(Frequency);
  const [csvFile, setCsvFile] = useState(CsvFile);
  const [riskDriver, setRiskDriver] = useState(RiskDriver);
  const [nextStepModel, setNextStepModel] = useState(NextStepModel);
  const [estimationApproach, setEstimationApproach] = useState(EstimationApproach);
  const [isComputing, setIsComputing] = useState(false);
  const [isError, setIsError] = useState(false);
  const [dataCols, setDataCols] = useState({});
  const [dataRows, setDataRows] = useState({});

  const apiName = 'restapimeucci';
  const path = '/data-process/estimation';
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: { 
      symbol: symbol,
      csvFile: csvFile,
      riskDriver: riskDriver,
      nextStepModel: nextStepModel,
      estimationApproach: estimationApproach
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsComputing(true);
 
      try {
        const response = await API.get(apiName, path, myInit);
        //console.log(response.data);
        //console.log(JSON.parse(response.data.output));
        setDataRows(JSON.parse(response.data.output));
        
        // reformat response.data.output to columns
        var date_arr = [];
        var value_arr = [];
        var riskDriver_arr = [];
        var invariant_arr = [];
        var equalWeightProb_arr = [];
        var expDecayProb_arr = [];

        JSON.parse(response.data.output).forEach((item) => {
          date_arr.push(item.Date);
          value_arr.push(item.Value);
          riskDriver_arr.push(item.RiskDriver);
          invariant_arr.push(item.Invariant);
          equalWeightProb_arr.push(item.EqualWeightProb);
          expDecayProb_arr.push(item.ExponentialDecayProb);
        });

        // ellipse coords for invariance test
/*         var hist_ew_arr = [];
        var bin_edges_ew_arr = [];
        JSON.parse(response.data.hist_ew).forEach((item) => {
          hist_ew_arr.push(item);
        }); */

        var hist_ew_arr = response.data.hist_ew;
        var bin_edges_ew_arr = response.data.bin_edges_ew;
        var hist_ed_arr = response.data.hist_ed;
        var bin_edges_ed_arr = response.data.bin_edges_ed;
        var stats_ew = response.data.stats_ew;
        var stats_ed = response.data.stats_ed;
/*         console.log(hist_ew_arr);
        console.log(bin_edges_ew_arr);
        console.log(hist_ed_arr);
        console.log(bin_edges_ed_arr); */

        //process equal weight probs
        var width_ew = Math.abs(bin_edges_ew_arr[0]- bin_edges_ew_arr[1]);
        let half_bin = width_ew/2;
        let bin_ew_midpoints = new Array(hist_ew_arr.length);
        for (let i = 0; i < hist_ew_arr.length; i++) {
          bin_ew_midpoints[i] = bin_edges_ew_arr[i] + half_bin;
        }
        //console.log(bin_ew_midpoints);
        var ew_widths = new Array(hist_ew_arr.length);
        ew_widths = ew_widths.fill(width_ew);
        //console.log('ew freq: ' + hist_ew_arr);
        //console.log('ew bin mid: ' + bin_ew_midpoints);
        //console.log('ew width: ' + ew_widths);

        //process exponential decay probs
        var width_ed = Math.abs(bin_edges_ed_arr[0]- bin_edges_ed_arr[1]);
        half_bin = width_ed/2;
        let bin_ed_midpoints = new Array(hist_ed_arr.length);
        for (let i = 0; i < hist_ed_arr.length; i++) {
          bin_ed_midpoints[i] = bin_edges_ed_arr[i] + half_bin;
        }
        //console.log(bin_ed_midpoints);
        var ed_widths = new Array(hist_ed_arr.length);
        ed_widths = ed_widths.fill(width_ed);
        //console.log('ed freq: ' + hist_ed_arr);
        //console.log('ed bin mid: ' + bin_ed_midpoints);
        //console.log('ed width: ' + ed_widths);


        setDataCols({'Date': date_arr, 'Value': value_arr, 'RiskDriver': riskDriver_arr, 'Invariant': invariant_arr,
          'EqualWeightProb': equalWeightProb_arr, 'ExponentialDecayProb': expDecayProb_arr, 'HistEW': hist_ew_arr,
          'BinMidsEW': bin_ew_midpoints, 'WidthsEW': ew_widths, 'StatsEW': stats_ew, 'HistED': hist_ed_arr, 'BinMidsED': bin_ed_midpoints,
          'WidthsED': ed_widths, 'StatsED': stats_ed
        });

      } catch (error) {
        setIsError(true);
        onError(error);
      }
 
      setIsComputing(false);
    };

    //console.log('Trying fetch : symbol=' + symbol + ' riskDriver=' + riskDriver);
    if (symbol !== "" && riskDriver !== "" && nextStepModel !== "" && estimationApproach !== "") {
      fetchData();
      //console.log('Fetch OK! ' + symbol + ' ' + riskDriver);
    }

  }, [symbol, riskDriver, nextStepModel, estimationApproach]);
 
  return [{ dataCols, dataRows, isComputing, isError }, setSymbol, setFrequency, setCsvFile, setRiskDriver, 
    setNextStepModel, setEstimationApproach];
};


export default function Estimation() {
  const [isLoading, setIsLoading] = useState(true);
  const [timeSeriess, setTimeSeriess] = useState(null);
  const [symbol, setSymbol] = useState(null);
  const [frequency, setFrequency] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [riskDriver, setRiskDriver] = useState("");
  const [nextStepModel, setNextStepModel] = useState("");
  const [estimationApproach, setEstimationApproach] = useState("");
  const [timeSeriesSelected, setTimeSeriesSelected] = useState(false);
  const [riskDriverSelected, setRiskDriverSelected] = useState(false);
  const [nextStepModelSelected, setNextStepModelSelected] = useState(false);
  const [estimationApproachSelected, setEstimationApproachSelected] = useState(false);
  //const [flexibleProbabilitiesSelected, setFlexibleProbabilitiesSelected] = useState(false);

  const [{ dataCols, dataRows, isComputing, isError }, 
    setSymbolArg, setFrequencyArg, setCsvFileArg, setRiskDriverArg, setNextStepModelArg, setEstimationApproachArg] = useRestApi(
      symbol, frequency, csvFile, riskDriver, nextStepModel, estimationApproach);

  useEffect(() => {
    // fetch async data within useEffect hook (not as separate function) otherwise big problems
    // https://blog.logrocket.com/usestate-vs-useref/
    const fetchData = async () => {
      try {
        const apiData = await API.graphql({ query: myListTimeSeriess });
        const tsFromApi = apiData.data.listTimeSeriess.items;
        await Promise.all(tsFromApi);
        setTimeSeriess(apiData.data.listTimeSeriess.items);
        //console.log('tsFromApi len = ' + tsFromApi.length);
        //for (const [key, value] of Object.entries(tsFromApi)) {
          //console.log(`${key}: ${value.symbol}|${value.frequency}|${value.csvFile}`);
        //} 
      } catch (error) {
        onError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  function handleInputChange(event) {
    // used for disabling submit button
    switch (event.target.id) {
      case "selectTimeSeries":
        setTimeSeriesSelected(true);
        break;
      case "selectRiskDriver":
        //setRiskDriver(event.target.value);
        setRiskDriverSelected(true);
        break;
      case "selectNextStepModel":
        setNextStepModelSelected(true);
        break;
      case "selectEstimationApproach":
        setEstimationApproachSelected(true);
        break;
/*       case "selectFlexibleProbabilities":
        setFlexibleProbabilitiesSelected(true);
        break; */
      default:
        console.log("No input change.");
        break;
    }
    console.log("Input changed: " + event.target.id + " - " + event.target.value);
  }

  function validateForm() {
    // disables submit button if inputs not selected
    return (timeSeriesSelected) && (riskDriverSelected) && (nextStepModelSelected) && 
        (estimationApproachSelected);
  }

  function handleSubmit(event) {
    let timeSeriesParams = document.getElementById('selectTimeSeries').value.split("|");
    setSymbol(timeSeriesParams[0]);
    setFrequency(timeSeriesParams[1]);
    setCsvFile(timeSeriesParams[2]);
    setSymbolArg(timeSeriesParams[0]);
    setFrequencyArg(timeSeriesParams[1]);
    setCsvFileArg(timeSeriesParams[2]);
    setRiskDriver(document.getElementById('selectRiskDriver').value);
    setRiskDriverArg(document.getElementById('selectRiskDriver').value);
    setNextStepModel(document.getElementById('selectNextStepModel').value);
    setNextStepModelArg(document.getElementById('selectNextStepModel').value);
    setEstimationApproach(document.getElementById('selectEstimationApproach').value);
    setEstimationApproachArg(document.getElementById('selectEstimationApproach').value);
    event.preventDefault();
  }

  function ControlledTabs(props) {
    return (
      
      <div style={{display: 'block', width: '100%'}}>
        <Tabs defaultActiveKey="chart">
          <Tab eventKey="chart" title="Chart">
            <br />
            <QuestCharts dataCols={props.dataCols}/>
          </Tab>
          <Tab eventKey="data" title="Data">
            <br />
            <DataTable dataRows={props.dataRows}/>
          </Tab>
          <Tab eventKey="desc" title="Description">
            <br />  
            <Table size="sm" className="table table-borderless">
              <tbody>
                <tr>
                  <td className="col-md-3"><strong>Symbol:</strong></td>
                  <td className="col-md-9">{props.symbol}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Frequency:</strong></td>
                  <td className="col-md-9">{startCase(props.frequency)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Data File:</strong></td>
                  <td className="col-md-9">{props.csvFile}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Risk Driver:</strong></td>
                  <td className="col-md-9">{startCase(props.riskDriver)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Next Step Model:</strong></td>
                  <td className="col-md-9">{startCase(props.nextStepModel)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Estimation Approach:</strong></td>
                  <td className="col-md-9">{startCase(props.estimationApproach)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Summary:</strong></td>
                  <td className="col-md-9">
                  Data has {props.dataCols.Date.length} rows and 6 columns:<br />
                    <ul>
                      <li>Date</li>
                      <li>Value</li>
                      <li>Risk Driver</li>
                      <li>Invariant</li>
                      <li>Equal Weight Prob</li>
                      <li>Exponential Decay Prob</li>
                    </ul>                
                  </td>
                </tr>
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </div>
    );
  }
  
  function QuestCharts(props) {
    // https://codepen.io/plotly/pen/KpLVzv


/*     [
      '#1f77b4',  # muted blue
      '#ff7f0e',  # safety orange
      '#2ca02c',  # cooked asparagus green
      '#d62728',  # brick red
      '#9467bd',  # muted purple
      '#8c564b',  # chestnut brown
      '#e377c2',  # raspberry yogurt pink
      '#7f7f7f',  # middle gray
      '#bcbd22',  # curry yellow-green
      '#17becf'   # blue-teal
  ] */
 
    var trace0 = {
      type: 'bar',
      x: props.dataCols.BinMidsEW,
      y: props.dataCols.HistEW,
      width: props.dataCols.WidthsEW,
      offset: -props.dataCols.WidthsEW[0]/2
    }
    
    var trace4 = {
      type: 'bar',
      x: props.dataCols.BinMidsED,
      y: props.dataCols.HistED,
      width: props.dataCols.WidthsED,
      offset: -props.dataCols.WidthsED[0]/2
    }
    
/*    var trace1 = {
      x: props.dataCols.Date,
      y: props.dataCols.EqualWeightProb,
      name: "Equal weight probs",
      type: "line",
      mode: 'lines',
      marker: {color: '#1f77b4'}, //muted blue
    };
    var trace2 = {
      x: props.dataCols.Date,
      y: props.dataCols.ExponentialDecayProb,
      name: "Exp. decay probs",
      type: "line",
      mode: 'lines',
      marker: {color: '#ff7f0e'},
    };
     var trace3 = {
      x: props.dataCols.Invariant,
      name: "Invariant",
      type: "histogram",
      marker: {
        color: '#1f77b4', // safety orange
      },
      histnorm: 'probability',
      xbins: {
        start: -0.203419135315326,
        end: 0.12025064,
        size: 0.03236697709969111
      }
    }; */

    return (
      <>
      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.ExponentialDecayProb,
              type: 'line',
              mode: 'markers',
              //color: props.dataCols.ExponentialDecayProb,
              //marker: {color: 'Orange'},
              marker: {
                size: 4,
                cmax: 0.02,
                cmin: 0,
                color: props.dataCols.ExponentialDecayProb,
                colorbar: {
                  title: "Colorbar"
                },
                colorscale: "Viridis" //"RdBu"
              },
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Exponential Decay Time Conditioned Probabilities',
          } }
        /> 
      </div>

      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.Invariant,
              type: 'line',
              mode: 'markers',
              marker: {
                size: 5,
                cmax: 0.02,
                cmin: 0,
                color: props.dataCols.ExponentialDecayProb,
                colorscale: "Viridis"
              },
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Invariants'
          } }
        /> 
      </div>

      <div>
        <Plot
            data={[trace4]}
            config={ {responsive: true} }
            layout={ {title: 'Distribution of Invariants with Exponential Decay Probs',
                      showlegend: false,

            } }
          />    
          <p>Mean: {Number.parseFloat(props.dataCols.StatsED[0]).toFixed(6)}<br />
          Std: {Number.parseFloat(props.dataCols.StatsED[1]).toFixed(6)}</p> 

      </div>
      <hr className="featurette-divider" />
      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.EqualWeightProb,
              type: 'scatter',
              mode: 'markers',
              marker: {
                size: 4,
                cmax: 0.02,
                cmin: 0,
                color: props.dataCols.EqualWeightProb,
                colorbar: {
                  title: "Colorbar"
                },
                colorscale: "Viridis", //"RdBu",
              },
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Equal Weight Probabilities',
            xaxis: {range: [0.9*Math.min(props.dataCols.EqualWeightProb), 1.1*Math.max(props.dataCols.EqualWeightProb)]}
          } }
        /> 
      </div>

      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.Invariant,
              type: 'line',
              mode: 'markers',
              marker: {
                size: 5,
                cmax: 0.02,
                cmin: 0,
                color: props.dataCols.EqualWeightProb,
                colorscale: "Viridis"
              },
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Invariants'
          } }
        /> 
      </div>

      <div>
        <Plot
            data={[trace0]}
            config={ {responsive: true} }
            layout={ {title: 'Distribution of Invariants with Equal Weight Probs',
                      showlegend: false,

            } }
          />  
          <p>Mean: {Number.parseFloat(props.dataCols.StatsEW[0]).toFixed(6)}<br />
          Std: {Number.parseFloat(props.dataCols.StatsEW[1]).toFixed(6)}</p> 
      
      </div>


{/*       <div>
        <Plot
            data={[trace1, trace2]}
            config={ {responsive: true} }
            layout={ {title: 'Equal Weight and Exponential Decay Time Conditioned Probabilities',
                      showlegend: true,
                      xaxis: {
                        zeroline: false,
                        showline: false,
                        showgrid: true,
                      },
            } }
          />        
      </div>
      <hr className="featurette-divider" /> */}
      </>
    );  
  }
  
  function DataTable(props) {
    // data must be in rows
    //console.log('test dt: ' + props.dataRows);
    const dataTableColumns = [
      {
        dataField: "Date",
        text: "Date",
        sort: true
      },
      {
        dataField: "Value",
        text: "Value",
      },
      {
        dataField: "RiskDriver",
        text: "Risk Driver"
      },
      {
        dataField: "Invariant",
        text: "Invariant"
      },     
      {
        dataField: "EqualWeightProb",
        text: "Equal Weight Prob"
      },      
      {
        dataField: "ExponentialDecayProb",
        text: "Exp. Decay Prob"
      }      
    ];
    return (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="Date"
          data={props.dataRows}
          columns={dataTableColumns}
          pagination={paginationFactory({ sizePerPage: 100 })}
          striped
          hover
          condensed
        />
      </div>
    );
  }


  return (
    <main className="flex-shrink-0">
      <div className="container">
        <h4 className="mt-3">Estimation</h4>
        <br />
        <div className="container">
          <div className="row">
            {isError && <div>Error occurred [useRestApi function?] ...</div>}
            <div className="col-3">
              { isLoading ? (
                <Spinner animation="border" style={{color: "#990000"}}/>
                ) : (
                <>
                <div className="card">
                  <div className="card-body">
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTimeSeries">
                          <Form.Label>Time series:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="" key="0">Select time series...</option>
                            {
                              Object.entries(timeSeriess).map(([key, value], index) => {
                                return(
                                  <option key={key+1} value={value.symbol + '|' + value.frequency + '|' + value.csvFile} data-type="text">{value.symbol}_{value.frequency}</option>
                                )
                              })
                            }                                
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectRiskDriver">
                          <Form.Label>Risk Driver:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select risk driver...</option>
                            <option value="value">Value</option>
                            <option value="logValue">Log Value</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectNextStepModel">
                          <Form.Label>Next Step Model:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select next step model...</option>
                            <option value="randomWalk">Random Walk</option>
                            <option value="Garch11">GARCH(1,1)</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectEstimationApproach">
                          <Form.Label>Estimation Approach:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select estimation approach...</option>
                            <option value="historical">Historical with Flexible Probabilities</option>
                            <option value="copulaMarginal" disabled>Copula-Marginal</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
{/*                       <Row>
                        <Form.Group as={Col} size="lg" controlId="selectFlexibleProbabilities">
                          <Form.Label>Flexible Probabilities:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select flexible probabilities...</option>
                            <option value="equalWeight">Equal Weight</option>
                            <option value="timeConditioned">Time Conditioned</option>
                            <option value="vixConditioned">VIX State Conditioned</option>
                            <option value="timeAndVixConditioned" disabled>Time and VIX conditioned</option>
                          </Form.Control>
                        </Form.Group>
                      </Row> */}
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="buttonSubmit">
                          <LoaderButton
                            size="md"
                            type="submit"
                            isLoading={isComputing}
                            disabled={!validateForm()}
                          >
                            Estimate
                          </LoaderButton>
                        </Form.Group>
                      </Row>
                    </Form>
                  </div>
                </div>
                </>
                )
              }
            </div>
            <div className="col-9">
              { !isComputing && Object.keys(dataCols).length > 0 &&
                <ControlledTabs dataCols={dataCols} dataRows={dataRows} symbol={symbol} frequency={frequency} csvFile={csvFile} 
                riskDriver={riskDriver} nextStepModel={nextStepModel} estimationApproach={estimationApproach}/>
              } 
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}